// Saved views for Performance Summary pivot table.
// built-in presets are named dimension/filter bundles; users can save their own.
// Presets can be scoped to specific tenants via `tenants` array.

const STORAGE_KEY = 'performance_summary_user_views_v1';
const LAST_VIEW_KEY = 'performance_summary_last_view_v1';

export const BUILTIN_PRESETS = [
  {
    key: 'contract_performance',
    name: 'Contract Performance',
    tenants: ['diverge'],
    state: {
      activeEntityType: 'Market',
      activeDimensions: ['contract'],

      columnFilters: {},
      hiddenMetricIds: [],
      sortKey: null,
      sortAsc: true,
    },
  },
  {
    key: 'market_performance',
    name: 'Market Performance',
    tenants: ['diverge'],
    state: {
      activeEntityType: 'Market',
      activeDimensions: [],

      columnFilters: {},
      hiddenMetricIds: [],
      sortKey: null,
      sortAsc: true,
    },
  },
];

export function loadUserViews() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveUserViews(views) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
}

export function loadLastViewKey() {
  return localStorage.getItem(LAST_VIEW_KEY);
}

export function saveLastViewKey(key) {
  if (key) localStorage.setItem(LAST_VIEW_KEY, key);
  else localStorage.removeItem(LAST_VIEW_KEY);
}
